import type {GetServiceCenterBannerParams} from '@/api/bffSupport';

import {queryOptions} from '@tanstack/react-query';
import {getCurrentUserId} from '@travel-frontend/user-id';

import {getServiceCenterBanner} from '@/api/bffSupport';

export const serviceCenterBanner = (params: GetServiceCenterBannerParams) => {
  return queryOptions({
    queryKey: ['bff-support', 'service-center-banner', params],
    queryFn: async ({signal}) => {
      const response = await getServiceCenterBanner(params, {
        signal,
        headers: {
          'X-User-Id': getCurrentUserId(),
        },
      });
      if (response.status !== 200) {
        throw new Error('Failed to fetch service center banner data');
      }

      return response.data;
    },
  });
};
